<template>
  <div class="pb-1 address">
    <router-link
      v-if="address.id"
      class="d-block text-derect"
      :to="{ name: 'edit-address', params: { id: address.id } }"
    >
      <div class="component position-relative">
        <div class="card border-0 sd-address-card bg-gray">
          <div class="card-body">
            <div class="clearfix">
              <div class="details">
                <div class="title">
                  <strong class="text-uppercase">
                    <span class="d-block" v-if="address.name_location">
                      {{ address.name_location }}
                    </span>
                    <span class="d-block">
                      <span class="d-inline-block mr-1">{{
                        address.street
                      }}</span>
                      {{ address.street_number }} {{ address.house_addition }}
                    </span>
                    <span class="d-block">
                      <span class="d-inline-block mr-2">{{
                        address.postal_code
                      }}</span>
                      {{ address.city }}
                    </span>
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </router-link>
    <router-link v-else class="d-block text-derect" :to="address.edit">
      <div class="component position-relative">
        <div class="card border-0 rounded-0 bg-gray">
          <div class="card-body">
            <div class="clearfix">
              <div class="details">
                <div class="title">
                  <strong class="text-uppercase">
                    <span class="d-block" v-if="address.name_location">
                      {{ address.name_location }}
                    </span>
                    <span class="d-block">
                      <span class="d-inline-block mr-1">{{
                        address.street
                      }}</span>
                      {{ address.street_number }} {{ address.house_addition }}
                    </span>
                    <span class="d-block">
                      <span class="d-inline-block mr-2">{{
                        address.postal_code
                      }}</span>
                      {{ address.city }}
                    </span>
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    address: Object
  }
};
</script>

<style scoped>
.sd-address-card {
  border-radius: 10px;
}
</style>
